import '@ali/aps-dev/dist/css/aps.css';
import React, { Component } from 'react';
import { Grid } from '@ali/aps-dev';
import { observer, inject } from 'mobx-react';
import CheckItem from './CheckItem';
import './screen.scss';

const Row = Grid.Row;

@inject('checkListStore')
@observer
class CheckList extends Component {
  constructor(props) {
    super(props);
    this.checkListStore = this.props.checkListStore;
    this.labelObj = this.checkListStore.labelObj;
    this.labelTags = this.checkListStore.labelTags;
  }
  handlerChangeCheck(key, event) {
    this.checkListStore.handlerChangeCheck(key, event);
  }

  render() {
    let rowsList = [];
    let index = 0;
    for (let key in this.labelObj) {
      rowsList.push(
        <CheckItem
          key={index++}
          labelTag={this.labelTags[key]}
          items={this.labelObj[key]}
          handlerChangeCheck={this.handlerChangeCheck.bind(this, key)}
          label={this.checkListStore.labels[key]}
          isPc={true} />
      );
    }
    return (
      <div>
        <Row className="check-list checks-pc">
          {rowsList}
          <div className="more-link">
            <a target="_blank" href="https://mi.aliyun.com/#eyJwcm9kdWN0VHlwZSI6N30=">筛选更多白金域名></a>
          </div>
        </Row>
      </div>
    );
  }
}
export default CheckList;


// WEBPACK FOOTER //
// ./src/components/Screen/CheckList.js